import { render, staticRenderFns } from "./HomeSocialProof.vue?vue&type=template&id=9f71bc42&scoped=true"
import script from "./HomeSocialProof.js?vue&type=script&lang=js&external"
export * from "./HomeSocialProof.js?vue&type=script&lang=js&external"
import style0 from "./HomeSocialProof.scss?vue&type=style&index=0&id=9f71bc42&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f71bc42",
  null
  
)

export default component.exports